import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, Card, CardContent, Grid, Typography, CardActionArea, CardMedia, FormGroup } from '@material-ui/core';
import { ImageOff } from 'lucide-react';

import { addToOrder, removeFromOrder } from '../actions';
import { useStyles } from '../styles';
import request from '../api';
import { getRestauranteFromStorage, ensureRestauranteLoaded } from '../services/selectedRestaurante';

export const DialogPopup = ({ product, isOpen, setIsOpen, orderItems, dispatch }) => {
    const [restaurante, setRestaurante] = useState({});
    const styles = useStyles(restaurante);
    const [quantity, setQuantity] = useState(1);
    const [imageErrors, setImageErrors] = useState({});

    // Usando um estado local para manipular a atualização de 'product'
    const [productState, setProductState] = useState(product);


    useEffect(() => {
        const loadRestaurante = async () => {
            let rest = getRestauranteFromStorage();
            if (!rest) {
                rest = await ensureRestauranteLoaded();
            }

            setRestaurante(rest || {});
            if (rest) localStorage.setItem('restaurante', JSON.stringify(rest));
        };

        loadRestaurante();
    }, []);

    useEffect(() => {
        // Sincroniza o 'productState' quando o 'product' prop mudar
        setProductState(product);
    }, [product]);

    const closeHandler = () => {
        setIsOpen(false);
    };

    const removeOrCancelOrder = () => {
        removeFromOrder(dispatch, product);
        setIsOpen(false);
    };

    const addToOrderHandler = () => {

        try {
            if (productState.produtoProdutoModificador) {
                productState.produtoProdutoModificador.forEach((prodProdModi) => {
                    if (prodProdModi.produtoModificador.produtoModificadorItems) {
                        let quantidadeSelecionado = 0;

                        prodProdModi.produtoModificador.produtoModificadorItems.filter((prodModItem) => prodModItem.visivel).forEach((prodModItem) => {
                            if (prodModItem.checked) {
                                quantidadeSelecionado = quantidadeSelecionado + 1;
                            }
                        });

                        if (quantidadeSelecionado < prodProdModi.produtoModificador.minimo) {
                            throw new Error('Modifiers obrigatórios nao selecionados')
                        }
                    }
                })
            }

            if (!productState.uniqueId)
                productState.uniqueId = Date.now() + '_' + Math.floor(Math.random() * 1000000);

            const modifierCount = productState.produtoProdutoModificador?.reduce((total, prodProdMod) => {
                return total + (prodProdMod.produtoModificador.produtoModificadorItems?.filter(item => item.checked)?.length || 0);
            }, 0) || 0;

            // appLogger.logUserAction('ProductAddedToOrder', {
            //     ProductId: productState.id,
            //     ProductName: productState.nome,
            //     ProductPrice: productState.preco,
            //     Quantity: quantity,
            //     ModifierCount: modifierCount,
            //     SelectedModifiers: productState.produtoProdutoModificador?.map(prodProdMod => ({
            //         ModifierId: prodProdMod.produtoModificador.id,
            //         ModifierName: prodProdMod.produtoModificador.nome,
            //         Items: prodProdMod.produtoModificador.produtoModificadorItems?.filter(item => item.checked)?.map(item => ({
            //             ItemId: item.id,
            //             ItemName: item.nome,
            //             ItemPrice: item.preco
            //         })) || []
            //     })) || []
            // });

            addToOrder(dispatch, { ...productState, quantity });
            setIsOpen(false);

        } catch (error) {
            console.log(error)
            // appLogger.error('Erro ao adicionar produto ao pedido', {
            //     ProductId: productState.id,
            //     ProductName: productState.nome,
            //     ErrorMessage: error.message
            // }, error);
        }
    };

    const handleChangeModifier = (event) => {
        const { name, checked } = event.target;

        const modiGroup = name.split('_')[0];
        const modiItem = name.split('_')[1];

        const updatedProduct = { ...productState };
        const prodModi = updatedProduct.produtoProdutoModificador.find(
            (prodProdMod) => prodProdMod.produtoModificador.id == modiGroup
        );

        prodModi.produtoModificador.produtoModificadorItems = prodModi.produtoModificador.produtoModificadorItems.map((item) => {
            if (item.id == modiItem) {
                return { ...item, checked };
            }
            return item;
        });

        const selecionados = prodModi.produtoModificador.produtoModificadorItems.filter((item) => item.visivel && item.checked === true);

        if (prodModi.produtoModificador.maximo == selecionados.length) {
            prodModi.produtoModificador.produtoModificadorItems.filter((item) => item.visivel).forEach((item) => {
                if (!item.checked)
                    item.disabled = true;
            });
        }
        if (prodModi.produtoModificador.maximo > selecionados.length) {
            prodModi.produtoModificador.produtoModificadorItems.filter((item) => item.visivel).forEach((item) => {
                if (!item.checked)
                    item.disabled = false;
            });
        }

        setProductState(updatedProduct);

    };

    const handleImageError = (itemId) => {
        setImageErrors(prev => ({
            ...prev,
            [itemId]: true
        }));
    };

    const renderModifierImage = (modItem) => {
        const hasImageError = imageErrors[modItem.id];
        const hasValidImage = modItem.foto && modItem.foto.trim() !== '';

        if (!hasValidImage || hasImageError) {
            return (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5',
                        color: '#999',
                        zIndex: 0,
                        borderRadius: 3
                    }}
                >
                    <ImageOff size={60} />
                </Box>
            );
        }

        return (
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${modItem.foto})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    opacity: 0.9,
                    zIndex: 0,
                    borderRadius: 3
                }}
                onError={() => handleImageError(modItem.id)}
            />
        );
    };


    const showModifiers = (product) => {
        return (
            <>
                {product.produtoProdutoModificador &&
                    product.produtoProdutoModificador.map((prodProdMod, ii) => {
                        return (
                            <Card key={ii} sx={{ width: 600 }}>
                                <CardContent sx={{ px: 2 }}>
                                    <Typography gutterBottom variant="h1" component="div" fontWeight="bold">
                                        {prodProdMod.produtoModificador.nome}
                                    </Typography>
                                    {prodProdMod.produtoModificador.descricao !== product.descricao && (
                                        <Typography variant="h2" sx={{ color: 'text.secondary' }}>
                                            {prodProdMod.produtoModificador.descricao}
                                        </Typography>
                                    )}

                                    <Box display="flex" flexDirection="column" gap={2} sx={{ mt: 3 }}>
                                        <FormGroup>
                                            <Grid container spacing={2}>

                                                {prodProdMod.produtoModificador.produtoModificadorItems.filter((modItem) => modItem.visivel).map((modItem, idx) => (
                                                    <Grid key={idx} item sx={6} md={6} lg={6}>
                                                        <Box
                                                            component="section"
                                                            sx={{
                                                                height: 240,
                                                                p: 2,
                                                                border: modItem.checked ? '3px solid #fa5b6d' : '1px solid #ccc',
                                                                borderRadius: 3,
                                                                transition: 'all 0.2s ease-in-out',
                                                                boxShadow: modItem.checked ? '0 0 0 4px rgba(250,91,109,0.3)' : 'none',
                                                                cursor: modItem.disabled ? 'not-allowed' : 'pointer',
                                                                backgroundColor: modItem.checked ? '#fff4f5' : '#fff',
                                                                '&:hover': {
                                                                    boxShadow: '0 0 8px rgba(0,0,0,0.1)'
                                                                },
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                textAlign: 'center',
                                                                position: 'relative',
                                                                overflow: 'hidden'
                                                            }}
                                                            onClick={() => {
                                                                if (modItem.disabled) return;
                                                                
                                                                handleChangeModifier({
                                                                    target: {
                                                                        name: prodProdMod.produtoModificador.id + '_' + modItem.id,
                                                                        checked: !modItem.checked,
                                                                    },
                                                                });
                                                            }}
                                                        >
                                                            {renderModifierImage(modItem)}
                                                            {modItem.checked && (
                                                                <Box
                                                                    sx={{
                                                                        position: 'absolute',
                                                                        top: 8,
                                                                        right: 8,
                                                                        backgroundColor: '#fa5b6d',
                                                                        color: '#fff',
                                                                        borderRadius: '50%',
                                                                        width: 90,
                                                                        height: 90,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        zIndex: 2
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: '60px' }} >✓</span>
                                                                </Box>
                                                            )}
                                                            <Box
                                                                sx={{
                                                                    position: 'absolute',
                                                                    bottom: 0,
                                                                    width: '100%',
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                                    color: '#fff',
                                                                    textAlign: 'center',
                                                                    py: 1,
                                                                    zIndex: 1
                                                                }}
                                                            >
                                                                <Typography variant="h3" fontWeight={600}>
                                                                    {modItem.nome}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </FormGroup>
                                    </Box>
                                </CardContent>
                            </Card>
                        );
                    })
                }
            </>
        );
    };

    return (
        <Dialog fullWidth={true} maxWidth={false} open={isOpen} onClose={closeHandler} sx={{ position: 'relative', maxWidth: '1000px', margin: 'auto' }}>
            <Box sx={{ backgroundColor: restaurante.corPrimaria || '#fa5b6d', color: '#fff', px: 4, py: 3 }}>
                <Typography variant="h1" sx={{ fontWeight: 900, mb: 3, fontSize: '4rem' }}>
                    {productState.nome}
                </Typography>
                <Typography variant="h4" sx={{ opacity: 0.95 }} style={{ color: 'white' }}>
                    {productState.descricao}
                </Typography>
            </Box>

            {productState.produtoProdutoModificador &&
                !!productState.produtoProdutoModificador.length &&
                <Box sx={{
                    maxHeight: 'calc(100vh - 160px)',
                    overflowY: 'auto',
                    marginLeft: 30,
                    marginRight: 30,
                    marginBottom: 180,
                    willChange: 'transform',
                    transform: 'translateZ(0)',
                    WebkitOverflowScrolling: 'touch'
                }}>                    {showModifiers(productState)}
                </Box>
            }

            {(!productState.produtoProdutoModificador || !productState.produtoProdutoModificador.length) &&

                <Box sx={{
                    maxHeight: 'calc(100vh - 160px)',
                    overflowY: 'auto',
                    marginLeft: 30,
                    marginRight: 30,
                    marginBottom: 180,
                    marginTop: 15,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    willChange: 'transform',
                    transform: 'translateZ(0)',
                    WebkitOverflowScrolling: 'touch'
                }}>
                    <Card sx={{ textAlign: 'center' }}  >
                        <CardActionArea>
                            <CardMedia style={{ width: 600 }}
                                component="img"
                                image={productState.foto}
                                alt={productState.nome}
                            />
                        </CardActionArea>
                    </Card>
                </Box>
            }

            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    p: 2,
                    boxShadow: '0 -4px 10px rgba(0,0,0,0.1)',
                    display: 'flex',
                    gap: '16px',
                    justifyContent: 'space-between',
                    height: '150px',
                    padding: '16px'
                }}
            >
                <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    fullWidth
                    onClick={removeOrCancelOrder}
                    sx={{
                        flex: 1,
                        height: '80px',
                        borderRadius: '12px',
                        fontWeight: 'bold',
                        borderWidth: '2px',
                        '&:hover': {
                            borderWidth: '2px',
                            backgroundColor: 'rgba(250, 91, 109, 0.05)'
                        }
                    }}
                >
                    <span style={{ fontSize: '34px', fontWeight: 'bold' }}>
                        {orderItems.some((x) => x.id === productState.id) && window.location.pathname == '/review' && 'Remover do pedido'}
                        {!orderItems.some((x) => x.id === productState.id) && 'Voltar'}
                        {orderItems.some((x) => x.id === productState.id) && window.location.pathname == '/order' && 'Voltar'}
                    </span>
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    onClick={addToOrderHandler}
                    sx={{
                        flex: 1,
                        height: '80px',
                        borderRadius: '12px',
                        fontWeight: 'bold',
                        boxShadow: '0 4px 8px rgba(250, 91, 109, 0.3)'
                    }}
                >
                    <span style={{ fontSize: '34px', fontWeight: 'bold' }}>Adicionar ao pedido</span>
                </Button>
            </Box>
        </Dialog>
    );
};
